import { ImagilityBaseResponse } from 'app-models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class OutsideImagilityService {
  encriptedData: any;

  constructor(private http:HttpClient) { }

  getDocumentTypeList(type,petitionId){
    return this.http.get(`/${type}/task/${petitionId}/documentTypes`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response.data;
        }else {
          return [];
        }
      })
    );
  }
  
  getUploadedDocuments(type,caseType,caseId){
    return this.http.get(`/${type}/${caseType}/${caseId}/documents`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response.data;
        }else {
          return [];
        }
      })
    );
  }
  
  getUploadedReceiptList(type,caseType,caseId,taskStepId,receiptType){
    return this.http.get(`/${type}/${caseType}/${caseId}/document/taskStep/${taskStepId}/category/${receiptType}`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response.data;
        }else {
          return [];
        }
      })
    );
  }
  
  postReceipt(type,caseType,caseId,taskStepId,receiptType,receiptNumber,receiptCategory,receiptDate,filingDate,payload){
    const encryptedText = this.toEncrypt(receiptNumber);
    return this.http.post(`/${type}/${caseType}/${caseId}/document/taskStep/${taskStepId}/category/${receiptType}/entity/${encryptedText}/fileCategory/${receiptCategory}?fillingDate=${filingDate}&receiptDate=${receiptDate}`,payload).pipe(
      map((response: ImagilityBaseResponse) => {
        return response;
      })
    );
    
  }
  
  getReceiptInfo(type,caseType,caseId){
    return this.http.get(`/${type}/${caseType}/${caseId}/receiptInfo`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response.data;
        }else {
          return [];
        }
      })
    );
  }
  
  deleteReceipt(type,caseType,caseId,receiptId){
    return this.http.delete(`/${type}/${caseType}/${caseId}/receipt/${receiptId}`).pipe(
      map((response: ImagilityBaseResponse) => {
        return response; // send  full data
      })
    );
  }
  
  
  getReceipt(type,caseType,caseId,taskStepId,receiptType){
    return this.http.get(`/${type}/${caseType}/${caseId}/document/taskStep/${taskStepId}/category/${receiptType}`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response.data;
        }else {
          return [];
        }
      })
    );
  }
  postCaseStatus(recieptNumber: string, taskId: number){
    return this.http.post(`/casestatus/createbytaskid?recieptNumber=${recieptNumber}&taskId=${taskId}`, {}).pipe(
        map((response: ImagilityBaseResponse) => {
            if (response.status == 200) {
                return response;
            }
        })
    )
  }

  toEncrypt(_data) {
    var pharase = 'c63a423527b24f65'
    var data = _data;
    var key = CryptoJS.enc.Latin1.parse(pharase);
    var iv = CryptoJS.enc.Latin1.parse(pharase);
    var encrypted = CryptoJS.AES.encrypt(
      data,
      key,
      {
        iv: iv, mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
      }).toString();
    var e64 = CryptoJS.enc.Base64.parse(encrypted);
    var eHex = e64.toString(CryptoJS.enc.Hex);
    return this.encriptedData = eHex
  }


  
}
